// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".opacity[data-v-44ea7886] {\n  opacity: 0;\n}\n.app-main[data-v-44ea7886] {\n  width: calc(100% - 0px);\n  position: relative;\n  margin: 0;\n  flex-grow: 1;\n  display: flex;\n  flex-direction: column;\n  padding: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
